var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fad fa-spin fa-spinner text-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }